import { command, computed, state } from 'ccstate'

let _pathname: string | undefined = undefined
let _search: string | undefined = undefined

export const setPathname = (pathname: string) => {
  _pathname = pathname
}

export const setSearch = (search: string) => {
  _search = search
}

export function mockLocation(
  {
    pathname,
    search,
  }: {
        pathname: string
        search: string
    },
  signal: AbortSignal,
) {
  _pathname = pathname
  _search = search

  signal.addEventListener('abort', () => {
    _pathname = undefined
    _search = undefined
  })
}

export const pathname = () => {
  return _pathname ?? location.pathname
}

export const search = () => {
  return _search ?? location.search
}


export const reloadPathname$ = state(0)
export const pathname$ = computed((get) => {
  get(reloadPathname$)

  return pathname()
})

export const searchParams$ = computed((get) => {
  get(reloadPathname$)
  return new URLSearchParams(search())
})

export const updateSearchParams$ = command(({ set }, searchParams: URLSearchParams) => {
  const str = searchParams.toString()
  window.history.pushState({}, '', `${pathname()}${str ? `?${str}` : ''}`)
  set(reloadPathname$, (x) => x + 1)
})